const LogInfo = ({ data, timeLength=undefined, meridiem=true }) => {
	const formatTime = (dateString) => {
		const date = new Date(dateString);
		let options = {
			hour: "numeric",
			minute: "numeric",
			hour12: true,
			timeZone: "UTC"
		}

		if(timeLength=== "full"){
			options.second = "numeric"
		}
		if(!meridiem){
			options.hour12 = false;
		}

		return new Intl.DateTimeFormat("en-US", options).format(date);
	};
	return (
		<>
			<h4 className="flex gap-2 font-bold text-black text-label items-center">{data.log_name} {data.event ? (<><span className="w-[2px] h-3 bg-black"></span> <span>{data.event}</span></>) : "" }</h4>
			<div className="log-disc">
				<p className="text-xxs text-primary font-medium">{data.properties.created_by} <span className="text-grey-text">({data.properties.caused_by_user_role})</span></p>
				<p className="text-xxs font-medium text-grey-text mb-1">{formatTime(data.created_at)}</p>
			</div>
		</>
	)
}

export default LogInfo;